import * as types from './actions/types';

export default (
    state = {
        cartId: undefined,
        cartProducts: [],
        cartPrice: 0,
        cartQty: 0
    },
    action
) => {
    console.log(action.type);
    switch (action.type) {
        case types.GET_GUEST_CART_ID:
            return { ...state, cartId: action.cartId };
        case types.GET_GUEST_CART_PRODUCTS:
            return { ...state, cartProducts: action.cartProducts };
        case types.SET_CART_PRICE_AND_QTY:
            return {
                ...state,
                cartPrice: action.cartPrice,
                cartQty: action.cartQty
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/Cart/reducer.js